import { useState } from 'react'
import { RiLock2Line } from "react-icons/ri";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from 'react-router-dom';

import './css/perm.css'

export default function Permission() {

    const { t } = useTranslation();
    let navigate = useNavigate();

    return (
        <div className='noPermssionsBox'>
            <div>

                <RiLock2Line />
                
                <h3>{t("permssions_title")}</h3>
                <p>{t("permssions_short")} <b style={{color:"#000"}}>0507770313</b></p>


                <div style={{display:"flex", gap:20}}>
                    <Link style={{flex:1}} onClick={() => navigate(-1)} className='btn'>{t("return_btn")}</Link>
                    {/* <Link to='' style={{backgroundColor:"#666"}} onClick={() => navigate(-1)} className='btn'>{t("contact_us")}</Link> */}
                </div>
            </div>
        </div>
    )
}

